import { tween, styler } from 'popmotion';

// ----------------------------------------------------
// Time
// ----------------------------------------------------

export const msToTimeString = ms => {
  const sec = Math.round(ms / 1000);
  const min = Math.floor(sec / 60);
  return `${min}:${`0${sec % 60}`.slice(-2)}`;
};

// ----------------------------------------------------
// Scroll
// ----------------------------------------------------

const TOP_SCROLL = 63;
let scrollTween = null;

export const scrollToTop = () => {
  if (window.scrollY !== TOP_SCROLL) {
    if (scrollTween !== null) {
      scrollTween.stop();
    }
    scrollTween = tween({
      from: window.scrollY,
      to: TOP_SCROLL,
      duration: 500,
    }).start(styler(window).set('scrollTop'));
  }
};



// WEBPACK FOOTER //
// ./src/utils/index.js